const normalizeHref = (href) => {
    const path = href.split(/[?#]/u, 1)[0] ?? "/";
    if (path === "/")
        return path;
    return path.replace(/\/+$/u, "");
};
export const resolveApplicationNavigation = (groups, { capabilities = [], currentHref, }) => {
    const ids = new Set();
    const allowed = new Set(capabilities);
    const current = normalizeHref(currentHref);
    const filtered = groups.map((group) => {
        if (ids.has(group.id)) {
            throw new Error(`Duplicate navigation id "${group.id}".`);
        }
        ids.add(group.id);
        const items = group.items.filter((item) => !item.requiredCapability || allowed.has(item.requiredCapability));
        for (const item of items) {
            if (ids.has(item.id)) {
                throw new Error(`Duplicate navigation id "${item.id}".`);
            }
            ids.add(item.id);
        }
        return { ...group, items };
    });
    const candidates = filtered
        .flatMap((group) => group.items)
        .filter((item) => {
        const href = normalizeHref(item.href);
        return href === "/" ? current === "/" : current === href || current.startsWith(`${href}/`);
    })
        .sort((left, right) => normalizeHref(right.href).length - normalizeHref(left.href).length);
    const currentId = candidates[0]?.id;
    return filtered
        .map((group) => ({
        ...group,
        items: group.items.map((item) => ({
            ...item,
            current: item.id === currentId,
        })),
    }))
        .filter((group) => group.items.length > 0);
};
//# sourceMappingURL=navigation.js.map